export default __webpack_public_path__ + "static/natalia-g-a2d95cea9458131a1da453e29795ca28.jpg";